import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import rootReducer from '../reducers'

import config from '../utils/config';
const adminBaseUrl = config.ADMIN_BASE_URL
const ahBaseUrl = config.AH_BASE_URL

const configureStore = preloadedState => createStore(
  rootReducer,
  {adminBaseUrl, ahBaseUrl},
  applyMiddleware(thunk)
)

export default configureStore



// WEBPACK FOOTER //
// ./src/store/configureStore.prod.js